// Generated by CoffeeScript 1.11.1
(function() {
  var LayerInfo, NestedSectionDivider,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  LayerInfo = require('../layer_info');

  module.exports = NestedSectionDivider = (function(superClass) {
    extend(NestedSectionDivider, superClass);

    NestedSectionDivider.shouldParse = function(key) {
      return key === 'lsdk';
    };

    function NestedSectionDivider(layer, length) {
      NestedSectionDivider.__super__.constructor.call(this, layer, length);
      this.isFolder = false;
      this.isHidden = false;
    }

    NestedSectionDivider.prototype.parse = function() {
      var code;
      code = this.file.readInt();
      switch (code) {
        case 1:
        case 2:
          return this.isFolder = true;
        case 3:
          return this.isHidden = true;
      }
    };

    return NestedSectionDivider;

  })(LayerInfo);

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./lib/psd/layer_info/nested_section_divider.js
// module id = 69
// module chunks = 0